import * as firebase from 'firebase'

const config = {
  apiKey: "AIzaSyBHmG1stWaKinyzWDOjFUJhTMKOX6GrEto",
  authDomain: "personal-site-81d6d.firebaseapp.com",
  databaseURL: "https://personal-site-81d6d.firebaseio.com",
  storageBucket: "personal-site-81d6d.appspot.com",
  messagingSenderId: "479533265396"
}

firebase.initializeApp(config)
const firebaseDatabase = firebase.database()

export default firebaseDatabase



// WEBPACK FOOTER //
// ./src/redux/actions/firebaseDatabase.js